import styled from 'styled-components';
import { SyntheticEvent } from 'react';
import { BUTTON_SIZES, SecondaryButton } from 'ui/button';
import { Boss } from 'ui/icons/access/Boss';
import { WarningFillDiamond } from 'ui/icons/status/WarningFillDiamond';
import { Close16 } from 'ui/icons/action/Close16';
import { Body2, colors } from 'ui/theme';
import type { AnnouncementProps } from './Announcement';
import { Announcement } from './Announcement';
import { ANNOUNCEMENT_VARIANTS } from './constants';

type BossAnouncementProps = {
  isImpersonating?: boolean;
  onClickBoss: (e: SyntheticEvent) => void;
  onClickImpersonate: () => void;
  ProjectMetadataSlot?: React.ReactNode;
} & Omit<AnnouncementProps, 'variant'>;

export const BOSS_ANNOUNCEMENT_ID = 'boss-announcement';

const ImpersonatingLabel = styled(Body2)<{ isImpersonating: boolean }>`
  color: ${(props) => (props.isImpersonating ? '#fff' : '#555')};
`;

const OpenBossButton = styled(SecondaryButton)`
  &:not(:hover) path {
    fill: ${colors.textSecondary};
  }
`;

export const BossAnnouncement = ({
  isImpersonating = false,
  onClickBoss,
  onClickImpersonate,
  children,
  ProjectMetadataSlot,
}: BossAnouncementProps) => {
  const iconLabel = isImpersonating ? 'Impersonating' : 'BOSS';
  const iconColor = isImpersonating ? colors.white : colors.textSecondary;
  const variant = isImpersonating
    ? ANNOUNCEMENT_VARIANTS.BOSS_IMPERSONATING
    : ANNOUNCEMENT_VARIANTS.BOSS_DEFAULT;

  return (
    <Announcement
      id={BOSS_ANNOUNCEMENT_ID}
      ActionButton={
        <>
          {ProjectMetadataSlot}
          {isImpersonating && (
            <SecondaryButton size={BUTTON_SIZES.SMALL} onClick={onClickImpersonate}>
              <Close16 />
              Stop Impersonating
            </SecondaryButton>
          )}
          <OpenBossButton size={BUTTON_SIZES.SMALL} onClick={onClickBoss}>
            <Boss isColorInherited />
            Boss Controls
          </OpenBossButton>
        </>
      }
      Label={
        <>
          <WarningFillDiamond height={17} width={17} color={iconColor} />
          <ImpersonatingLabel isImpersonating={isImpersonating}>{iconLabel}</ImpersonatingLabel>
        </>
      }
      variant={variant}
    >
      {children}
    </Announcement>
  );
};
